import { contentStyles } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) `
  ${contentStyles}
`;
const RichTextBlockStyles = {
    Container,
};
export default RichTextBlockStyles;
